{
  "title": "Attribuer à un ménage",
  "body": "{{objectType}} sera associé au ménage, et l'utilisateur sera le contact principal.",
  "householdTitle": "Ménage",
  "name": "Nom",
  "modal": {
    "title": " Attribuer à un ménage"
  }
}
